import { IPublicClientApplication } from "@azure/msal-browser";
import { axiosGetRequest, axiosPostRequest } from "../../api/ApiClient";
import GenericUtils from "../../utils/GenericUtils";

const route = "/docente/v1";

async function getReserveWorkload(
    docenteId: number,
    initialDate: string,
    finalDate: string,
    msalInstance: IPublicClientApplication
) {
    return axiosGetRequest(
        `${route}/professores/${docenteId}/reservas-carga-horaria?data_inicio_vigencia=${initialDate}&data_fim_vigencia=${finalDate}`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function getCurricularMatrix(
    docenteId: number,
    initialDate: string,
    finalDate: string,
    msalInstance: IPublicClientApplication
) {
    return axiosGetRequest(
        `${route}/docentes/${docenteId}/naoletivamatrizcurriculares?query=dataAtualizacao >= date:${initialDate} and dataVigencia <= date:${finalDate}`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function getActivityPlan(
    docenteId: number,
    selectPeriods: string,
    msalInstance: IPublicClientApplication
) {
    return axiosGetRequest(
        `${route}/planosatividade/professores/${docenteId}/atividades-ultimo-plano-finalizado/${selectPeriods}`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

const endTach = async (
    docenteId: number,
    tachId: number,
    justification: string,
    msalInstance: IPublicClientApplication
) => {
    return axiosPostRequest(
        `${route}/tachs/${tachId}/finalizar`,
        {
            justificativa: justification,
        },
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
};

const getEndTachHistory = async (
    tachId: number,
    msalInstance: IPublicClientApplication
) => {
    return axiosGetRequest(
        `${route}/tachlogs?query=tachId=${tachId}`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
};

export default {
    getReserveWorkload,
    getCurricularMatrix,
    getActivityPlan,
    endTach,
    getEndTachHistory,
};
